import { FC } from 'react'
import { NonUndefined } from 'react-hook-form'

import LoadingButton from '@/components/loading-button'
import { ActionTimer } from '@/hooks/useActionTimer'
import { SSO } from '@/out/single-sign-on'
import { Label } from '@/components/ui/label'

type Props = {
  configuration: NonUndefined<SSO['okta']>
  timer: ActionTimer
  onRemove: () => void
}

const OktaDetails: FC<Props> = ({ configuration, timer, onRemove }) => {
  return (
    <div>
      <div className="pt-2 mb-6 space-y-3">
        <div className="flex flex-col gap-1 text-left">
          <Label className="text-muted-foreground">Okta Tenant:</Label>
          <span className="text-sm font-medium">{configuration.tenant}</span>
        </div>
        <div className="flex flex-col gap-1 text-left">
          <Label className="text-muted-foreground">Email Domain:</Label>
          <span className="text-sm font-medium">{configuration.domain}</span>
        </div>
        <div className="flex flex-col gap-1 text-left">
          <Label className="text-muted-foreground">Client ID:</Label>
          <span className="text-sm font-medium">{configuration.clientId}</span>
        </div>
        <div className="flex flex-col gap-1 text-left">
          <Label className="text-muted-foreground">Admin Group ID:</Label>
          <span className="text-sm font-medium">{configuration.adminGroupId}</span>
        </div>
        <div className="flex flex-col gap-1 text-left">
          <Label className="text-muted-foreground">Agent Group ID:</Label>
          <span className="text-sm font-medium">{configuration.agentGroupId}</span>
        </div>
      </div>
      <LoadingButton
        timer={timer}
        size="sm"
        onClick={onRemove}
        variant="outline"
        className="hover:bg-destructive hover:text-secondary"
      >
        Disconnect
      </LoadingButton>
    </div>
  )
}

export default OktaDetails
